import { RebuildHotline, getStaticProps } from '@public/RebuildHotline'

export { getStaticProps }

export default RebuildHotline
